// extracted by mini-css-extract-plugin
export default {"container":"modal_container__mx-db","hideOverflowInBody":"modal_hideOverflowInBody__GpA7A","info":"modal_info__ZCEUO","backDoor":"modal_backDoor__s+aJr"};